<template>
    <v-container>
        <ValidityCheck v-if="!validity" />
        <div v-else>
            <v-row>
                <v-col cols="12">
                    <h2 class="mt-5">Open Positions</h2>
                </v-col>
                <!-- <v-col cols="4">
                    <v-text-field
                        filled
                        v-model="search"
                        label="Search positions"
                        prepend-inner-icon="mdi-magnify"
                        clearable
                    ></v-text-field>
                </v-col> -->
                <v-col cols="4">
                    <v-select
                        @change="getPositions"
                        outlined
                        label="Status"
                        v-model="selectedStatus"
                        :items="statusList"
                    ></v-select>
                </v-col>
                <v-col cols="4" v-if="user && user.admin">
                    <v-btn color="primary" class="mt-2" @click="addItem">Add Position</v-btn>
                    <v-btn color="success" class="mt-2 ml-2" @click="$refs.fileInput.click()">Bulk Upload</v-btn>
                    <v-btn color="warning" class="mt-2 ml-2" @click="revertUpload">Revert Last Upload</v-btn>
                    <v-btn color="secondary" class="mt-2 ml-2" @click="$refs.history.openAll()">Change Log</v-btn>
                    <input type="file" ref="fileInput" class="d-none" accept=".csv" @change="handleFileUpload">
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :search="search"
                        :loading="loading"
                        :headers="headers"
                        :header-props="{ sortIcon: null }"
                        mobile-breakpoint="100"
                        :items="positions"
                        class="elevation-1 datat"
                    >
                        <template v-slot:[`item.current_view`]="{ item }">
                            <v-chip v-if="item.current_view == 'HOLD'" color="orange" text-color="white">{{ item.current_view }}</v-chip>
                            <v-chip v-if="item.current_view == 'CLOSE'" color="red" text-color="white">{{ item.current_view }}</v-chip>
                            <v-chip v-if="item.current_view == 'BUY'" color="green" text-color="white">{{ item.current_view }}</v-chip>
                        </template>
                        <template v-slot:[`item.entry_date`]="{ item }">
                            {{ new Date(item.entry_date).toLocaleDateString('en-IN') }}
                        </template>
                        <template v-slot:[`item.exit_date`]="{ item }">
                            <div v-if="item.exit_date">
                                {{ new Date(item.exit_date).toLocaleDateString('en-IN') }}
                            </div>
                            <div v-else>-</div>
                        </template>
                        <template v-slot:[`item.returns`]="{ item }">
                            <div v-if="item.returns <= 0" class="red--text">
                                {{ (item.returns * 100).toFixed(1) }}%
                            </div>
                            <div v-if="item.returns > 0" class="green--text">
                                {{ (item.returns * 100).toFixed(1) }}%
                            </div>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex align-center">
                            <v-btn
                                dark
                                @click="open(item)"
                                class="ma-2"
                                color="blue"
                                rounded
                                small
                            >
                                Updates
                            </v-btn>
                            <v-btn
                                @click="openPdf(item)"
                                class="ma-2 gradient-button"
                                rounded
                                small
                            >
                                Report
                            </v-btn>
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                                v-if="user && user.admin"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                @click="deleteItem(item)"
                                v-if="user && user.admin"
                            >
                                mdi-delete
                            </v-icon>
                            <v-icon
                                small
                                class="ml-2"
                                @click="$refs.history.openForPosition(item)"
                                v-if="user && user.admin"
                            >
                                mdi-history
                            </v-icon>
                            <v-icon
                                small
                                class="ml-2"
                                @click="$refs.emailDialog.open(item)"
                                v-if="user && user.admin"
                            >
                                mdi-email-outline
                            </v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <div>
                            <strong>Stock</strong> : It refers to NSE Symbol ||  
                            <strong>Industry</strong> : It refers to Basic Industry as defined in NSE ||  
                            <strong>Market Cap</strong> : It refers to segregation of stocks in Large, Mid and Small capitalization. ||  
                            <strong>Max Entry</strong> : It refers to Maximum Buy price Investors can pay ||  
                            <strong>Current View</strong> : It refers to view as of today ||  
                            <strong>CMP/CL</strong> : Current market price (Open positions) or Close price (Close positions) ||
                            <strong>Return</strong> : It refers to Absolute return generated from Max Buy price to today's market price. ||  
                            <strong>Actions - Report</strong> : Research report with original recommendation details ||  
                            <strong>Actions - Updates</strong> : Latest updates based on Quarterly results or key developments
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
            <v-row>
                <v-dialog v-model="dialogEdit" max-width="800px">
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.stock" label="Stock"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.company" label="Company"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.industry" label="Industry"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.mcap" label="Market Cap"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.entry_date" label="Entry Date" type="date"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.exit_date" label="Exit Date" type="date"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.max_entry" label="Max Entry" type="number"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-select v-model="editedItem.current_view" :items="['BUY', 'HOLD', 'CLOSE']" label="Current View"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.cmp" label="CMP" type="number"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.returns" label="Returns" type="number"></v-text-field></v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.package" label="Package"></v-text-field></v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeEdit">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row>
                <v-dialog v-model="previewDialog" max-width="800px">
                    <v-card>
                        <v-card-title>Bulk Upload Summary</v-card-title>
                        <v-card-text>
                            <v-alert type="info" border="left" colored-border elevation="2">
                                <strong>Total Records Processed:</strong> {{ uploadSummary.total }}
                            </v-alert>
                            <v-row>
                                <v-col cols="6">
                                    <v-card outlined class="pa-2 green lighten-5">
                                        <div class="subtitle-1 green--text font-weight-bold">To Add: {{ uploadSummary.toAdd.length }}</div>
                                        <v-list dense disabled class="green lighten-5">
                                            <v-list-item v-for="(item, i) in uploadSummary.toAdd.slice(0, 5)" :key="'add'+i">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ item.stock }}</v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.company }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item v-if="uploadSummary.toAdd.length > 5">
                                                <v-list-item-subtitle>...and {{ uploadSummary.toAdd.length - 5 }} more</v-list-item-subtitle>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                                <v-col cols="6">
                                    <v-card outlined class="pa-2 orange lighten-5">
                                        <div class="subtitle-1 orange--text font-weight-bold">To Update: {{ uploadSummary.toUpdate.length }}</div>
                                        <v-list dense disabled class="orange lighten-5">
                                            <v-list-item v-for="(item, i) in uploadSummary.toUpdate.slice(0, 5)" :key="'up'+i">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ item.stock }}</v-list-item-title>
                                                    <v-list-item-subtitle>ID: {{ item.id }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item v-if="uploadSummary.toUpdate.length > 5">
                                                <v-list-item-subtitle>...and {{ uploadSummary.toUpdate.length - 5 }} more</v-list-item-subtitle>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-alert v-if="uploadSummary.errors.length > 0" type="error" class="mt-3">
                                <strong>Errors ({{ uploadSummary.errors.length }}):</strong>
                                <ul>
                                    <li v-for="(err, i) in uploadSummary.errors.slice(0, 5)" :key="'err'+i">{{ err }}</li>
                                    <li v-if="uploadSummary.errors.length > 5">...and {{ uploadSummary.errors.length - 5 }} more</li>
                                </ul>
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="previewDialog = false">Cancel</v-btn>
                            <v-btn color="success" @click="confirmUpload" :disabled="uploadSummary.toAdd.length === 0 && uploadSummary.toUpdate.length === 0">Confirm Upload</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row>
                <v-dialog
                v-model="loadingDialog"
                hide-overlay
                persistent
                width="300"
                >
                <v-card
                    color="primary"
                    dark
                >
                    <v-card-text>
                    Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                    </v-card-text>
                </v-card>
                </v-dialog>
            </v-row>
            <v-row>
                <v-dialog v-model="dialog1"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition">
                    <v-card v-if="dialog1">
                        <v-toolbar
                        dark
                        color="primary"
                        >
                        <v-btn
                            icon
                            dark
                            @click="close"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ item.stock }} | {{ item.company }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-row>
                            <PdfViewer :pdfUrl="pdf" />
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row>
                <v-dialog v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition">
                    <v-card v-if="dialog">
                        <v-toolbar
                        dark
                        color="primary"
                        >
                        <v-btn
                            icon
                            dark
                            @click="close"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ item.stock }} | {{ item.company }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-container class="no-select" @contextmenu.prevent>
                            <v-row>
                                <v-col cols="12">
                                    <viewer :initialValue="research_data" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-dialog>
            </v-row>
            <PositionHistory ref="history" />
            <PositionEmail ref="emailDialog" />
        </div>
    </v-container>
</template>

<script>
import {supabase} from '../supabase'
import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
// import PdfViewer from './PdfViewer.vue';
import PdfViewer from './PdfViewer1.vue';
import ValidityCheck from './ValidityCheck.vue';
import PositionHistory from './PositionHistory.vue';
import PositionEmail from './PositionEmail.vue';
export default {
    data: () => ({
        headers: [
            // { text: 'Stock', value: 'stock', sortable: false, align: 'center' },
            // { text: 'Company', value: 'company', sortable: false, align: 'center' },
            // { text: 'Industry', value: 'industry', sortable: false, align: 'center' },
            // { text: 'Market Cap', value: 'mcap', sortable: false, align: 'center' },
            // { text: 'Entry Date', value: 'entry_date', sortable: false, align: 'center' },
            // { text: 'Exit Date', value: 'exit_date', sortable: false, align: 'center' },
            // { text: 'Max Entry', value: 'max_entry', sortable: false, align: 'center' },
            // { text: 'Current View', value: 'current_view', sortable: false, align: 'center' },
            // { text: 'CMP', value: 'cmp' , sortable: false, align: 'center'},
            // { text: 'Return', value: 'return', sortable: false, align: 'center' },
        ],
        positions: [],
        loading: false,
        search: '',
        statusList: ['ALL', 'BUY', 'HOLD'],
        selectedStatus: 'ALL',
        loadingDialog: false,
        research_data: '',
        pdf: '',
        dialog: false,
        dialog1: false,
        item: null,
        dialogEdit: false,
        editedIndex: -1,
        editedItem: {
            stock: '',
            company: '',
            industry: '',
            mcap: '',
            entry_date: '',
            exit_date: '',
            max_entry: 0,
            current_view: 'BUY',
            cmp: 0,
            returns: 0,
            package: ''
        },
        defaultItem: {
            stock: '',
            company: '',
            industry: '',
            mcap: '',
            entry_date: '',
            exit_date: '',
            max_entry: 0,
            current_view: 'BUY',
            cmp: 0,
            returns: 0,
            package: ''
        },
        previewDialog: false,
        uploadSummary: {
            total: 0,
            toAdd: [],
            toUpdate: [],
            errors: []
        },
    }),

    methods: {
        async getPositions () {
            this.loading = true;
            this.positions = []
            if(this.selectedStatus == 'ALL') {
                const { data, error } = await supabase
                    .from('positions')
                    .select('*')
                    .neq('current_view', 'CLOSE')
                    .order('entry_date', { ascending: false })
                    
                if (error) {
                    console.error('Error fetching positions:', error);
                    this.loading = false;
                } else {
                    this.positions = data;
                    this.loading = false;
                }
            } else {
                const { data, error } = await supabase
                    .from('positions')
                    .select('*')
                    .eq('current_view', this.selectedStatus)
                    .order('entry_date', { ascending: false })
                if (error) {
                    console.error('Error fetching positions:', error);
                    this.loading = false;
                } else {
                    this.positions = data;
                    this.loading = false;
                }
            }
            if (!this.user.admin && this.user.package !== 'PREMIUM') {
                this.positions = this.positions.filter(position => position.package !== 'P');
            }
        },

        async getColumns() {
            this.loading = true
            const { data, error } = await supabase
                .from('table_map')
                .select('*')
                .order('order', { ascending: true })
            if (error) {
                console.error('Error fetching positions:', error);
                this.loading = false;
            } else {
                for(let i in data) {
                    if(data[i].enable) {
                        this.headers.push({
                            text: data[i].label,
                            value: data[i].cno,
                            sortable: true,
                            align: 'center'
                        })
                    }
                }
                this.headers.push({
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                })

                this.loading = false;
            }
        },

        async open(item){
            this.loadingDialog = true
            const { data, error } = await supabase
                .from('researches')
                .select('research_data')
                .eq('position_id', item.id)
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                console.error('Error fetching positions:', error);
                this.loadingDialog = false
            } else {
                if(data.length > 0){
                    this.research_data = data[0].research_data
                    this.item = item
                    this.dialog = true
                    this.loadingDialog = false
                }
                else{
                    this.loadingDialog = false
                    this.$store.dispatch('createAlert',{type: 'error', message: 'No research found'})
                }
            }
        },

        async openPdf(item) {
            this.loadingDialog = true
            const { data, error } = await supabase
                .from('researches')
                .select('pdf')
                .eq('position_id', item.id)
            
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                console.error('Error fetching positions:', error);
                this.loadingDialog = false
            } else {
                if(data.length > 0){
                    this.pdf = data[0].pdf
                    this.item = item
                    this.dialog1 = true
                    this.loadingDialog = false
                }
                else{
                    this.loadingDialog = false
                    this.$store.dispatch('createAlert',{type: 'error', message: 'No research found'})
                }
            }
        },

        close() {
            this.loadingDialog = false
            this.dialog = false
            this.dialog1 = false
            this.item = null
        },

        addItem () {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
            this.dialogEdit = true
        },

        editItem (item) {
            this.editedIndex = this.positions.indexOf(item)
            this.editedItem = Object.assign({}, item)
            // Format dates for input type="date"
            if (this.editedItem.entry_date) this.editedItem.entry_date = new Date(this.editedItem.entry_date).toISOString().substr(0, 10)
            if (this.editedItem.exit_date) this.editedItem.exit_date = new Date(this.editedItem.exit_date).toISOString().substr(0, 10)
            this.dialogEdit = true
        },

        async deleteItem (item) {
            const index = this.positions.indexOf(item)
            if (confirm('Are you sure you want to delete this item?')) {
                const { error } = await supabase
                    .from('positions')
                    .delete()
                    .eq('id', item.id)
                if (error) {
                    console.error('Error deleting position:', error)
                    this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                } else {
                    this.positions.splice(index, 1)
                    this.$store.dispatch('createAlert',{type: 'success', message: 'Position deleted successfully'})
                }
            }
        },

        closeEdit () {
            this.dialogEdit = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        async save () {
            this.loadingDialog = true
            
            // Create a payload copy to safely modify data for the API call
            const payload = { ...this.editedItem }
            
            // Convert empty strings to null for timestamp columns to avoid syntax errors
            if (payload.entry_date === '') payload.entry_date = null
            if (payload.exit_date === '') payload.exit_date = null

            if (this.editedIndex > -1) {
                // Edit
                const { error } = await supabase
                    .from('positions')
                    .update(payload)
                    .eq('id', this.editedItem.id)
                
                if (error) {
                    console.error('Error updating position:', error)
                    this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                } else {
                    Object.assign(this.positions[this.editedIndex], payload)
                    this.$store.dispatch('createAlert',{type: 'success', message: 'Position updated successfully'})
                }
            } else {
                // Add
                // Manually fetch highest ID to set the new ID, preventing sequence sync issues
                const { data: maxResult, error: maxError } = await supabase
                    .from('positions')
                    .select('id')
                    .order('id', { ascending: false })
                    .limit(1)

                if (!maxError && maxResult && maxResult.length > 0) {
                    payload.id = maxResult[0].id + 1
                } else if (!maxError && maxResult.length === 0) {
                    payload.id = 1
                } else {
                    // Fallback: if checking max ID fails, remove ID and let DB try
                    delete payload.id
                }

                const { data, error } = await supabase
                    .from('positions')
                    .insert([payload])
                    .select()
                
                if (error) {
                    console.error('Error adding position:', error)
                    this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                } else {
                    if (data && data.length > 0) {
                        this.positions.unshift(data[0])
                    } else {
                        // If select() not returned, just re-fetch or push
                        this.getPositions()
                    }
                    this.$store.dispatch('createAlert',{type: 'success', message: 'Position added successfully'})
                }
            }
            this.loadingDialog = false
            this.closeEdit()
        },

        handleFileUpload(event) {
            const file = event.target.files[0]
            if (!file) return
            
            const reader = new FileReader()
            reader.onload = (e) => {
                const content = e.target.result
                this.processCSV(content)
            }
            reader.readAsText(file)
            // Reset input
            event.target.value = ''
        },

        processCSV(content) {
            const lines = content.split(/\r\n|\n/)
            // Row 0: Ignore
            // Row 1: Header
            if (lines.length < 2) {
                this.$store.dispatch('createAlert', { type: 'error', message: 'CSV file is empty or invalid format' })
                return
            }

            const headerLine = lines[1]
            const headers = this.parseCSVLine(headerLine)
            
            const rows = []
            for (let i = 2; i < lines.length; i++) {
                if (!lines[i].trim()) continue
                const row = this.parseCSVLine(lines[i])
                if (row.length === headers.length) {
                    const rowData = {}
                    headers.forEach((h, index) => {
                        rowData[h.trim()] = row[index] ? row[index].trim() : ''
                    })
                    rows.push(rowData)
                }
            }
            
            this.analyzeData(rows)
        },

        parseCSVLine(text) {
            // Simple CSV parser handling quotes
            const matches = []
            let match = ''
            let inQuotes = false
            for (let i = 0; i < text.length; i++) {
                const char = text[i]
                if (char === '"') {
                    inQuotes = !inQuotes
                } else if (char === ',' && !inQuotes) {
                    matches.push(match)
                    match = ''
                } else {
                    match += char
                }
            }
            matches.push(match)
            return matches.map(m => m.replace(/^"|"$/g, '').replace(/""/g, '"'))
        },

        async analyzeData(rows) {
            this.loadingDialog = true
            // Fetch all positions for validation/duplication check
            const { data: allPositions, error } = await supabase
                .from('positions')
                .select('*')
            
            if (error) {
                this.loadingDialog = false
                this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to fetch existing positions for validation' })
                return
            }

            this.uploadSummary = {
                total: rows.length,
                toAdd: [],
                toUpdate: [],
                errors: []
            }

            rows.forEach((row, index) => {
                try {
                    // Mapping
                    const item = {
                        stock: row['Stock'],
                        company: row['Company'],
                        industry: row['Industry'],
                        mcap: row['Market Cap'],
                        entry_date: this.parseDate(row['Entry Date']),
                        exit_date: this.parseDate(row['Exit Date']),
                        max_entry: parseFloat(row['Max Entry'] || 0),
                        current_view: row['Current View'],
                        cmp: row['CMP/CL'], // Keep as text or number? Schema says text for cmp
                        returns: this.parseReturn(row['Return']),
                        package: row['Package'],
                        c11: row['Custom$11'] || row['c11'],
                        c12: row['Custom#12'] || row['c12'],
                        c13: row['Custom#13'] || row['c13'],
                        c14: row['Custom#14'] || row['c14'],
                        c15: row['Custom#15'] || row['c15'],
                        c16: row['Custom#16'] || row['c16'],
                        c17: row['Custom#17'] || row['c17'],
                        c18: row['Custom#18'] || row['c18'],
                        c19: row['Custom#19'] || row['c19'],
                        c20: row['Custom#20'] || row['c20']
                    }

                    if (!item.stock || !item.entry_date) {
                        this.uploadSummary.errors.push(`Row ${index + 3}: Missing Stock or Entry Date`)
                        return
                    }

                    // Check for duplicate/existing based on Sr No -> id
                    const csvId = row['Sr No'] ? parseInt(row['Sr No'].trim()) : null

                    if (csvId) {
                        const existing = allPositions.find(p => p.id === csvId)
                        if (existing) {
                            item.id = existing.id
                            this.uploadSummary.toUpdate.push(item)
                        } else {
                            // Sr No provided but ID not found in DB -> Use Sr No as ID
                            item.id = csvId
                            this.uploadSummary.toAdd.push(item)
                        }
                    } else {
                        // No Sr No -> New entry
                        this.uploadSummary.toAdd.push(item)
                    }

                } catch (e) {
                    this.uploadSummary.errors.push(`Row ${index + 3}: Error parsing - ${e.message}`)
                }
            })

            this.loadingDialog = false
            this.previewDialog = true
        },

        parseDate(dateStr) {
            if (!dateStr) return null
            // Handles "29-Nov-25" or "18-Jun-2023"
            const parts = dateStr.split('-')
            if (parts.length !== 3) return null
            
            const day = parseInt(parts[0], 10)
            const monthStr = parts[1].toLowerCase()
            let year = parseInt(parts[2], 10)
            
            const months = {
                jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
                jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
            }
            
            if (year < 100) year += 2000
            
            // Return ISO string
            // Use UTC to avoid timezone shifts if possible, or just local
            const date = new Date(year, months[monthStr], day)
            // Adjust for timezone offset to ensure the date stays correct in ISO
            const offset = date.getTimezoneOffset()
            const dateLocal = new Date(date.getTime() - (offset*60*1000))
            return dateLocal.toISOString()
        },

        parseReturn(retStr) {
            if (!retStr) return 0
            // Remove % and convert to decimal
            return parseFloat(retStr.replace('%', '')) / 100
        },

        async confirmUpload() {
            this.loadingDialog = true
            let successCount = 0
            let failCount = 0
            
            const batchId = new Date().toISOString()
            let previousData = []
            let addedIds = []

            // 1. Prepare Backup for Updates
            if (this.uploadSummary.toUpdate.length > 0) {
                const updateIds = this.uploadSummary.toUpdate.map(p => p.id)
                const { data: oldRows, error: fetchError } = await supabase
                    .from('positions')
                    .select('*')
                    .in('id', updateIds)
                
                if (!fetchError && oldRows) {
                    previousData = oldRows
                } else {
                    console.error('Failed to fetch pre-update data for backup')
                }
            }

            // 2. Process Adds
            if (this.uploadSummary.toAdd.length > 0) {
                const { data: insertedData, error } = await supabase
                    .from('positions')
                    .insert(this.uploadSummary.toAdd)
                    .select('id') // Important: Get IDs of inserted rows
                
                if (error) {
                    console.error('Bulk Add Error:', error)
                    failCount += this.uploadSummary.toAdd.length
                    this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to add new positions: ' + error.message })
                } else {
                    successCount += this.uploadSummary.toAdd.length
                    if (insertedData) {
                        addedIds = insertedData.map(row => row.id)
                    }
                }
            }

            // 3. Process Updates
            if (this.uploadSummary.toUpdate.length > 0) {
                const { error } = await supabase
                    .from('positions')
                    .upsert(this.uploadSummary.toUpdate)
                
                if (error) {
                    console.error('Bulk Update Error:', error)
                    failCount += this.uploadSummary.toUpdate.length
                    this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to update positions: ' + error.message })
                } else {
                    successCount += this.uploadSummary.toUpdate.length
                }
            }

            // 4. Save Backup Record
            if (addedIds.length > 0 || previousData.length > 0) {
                
                // Delete previous backups to ensure only the last version is kept
                await supabase.from('position_backups').delete().gt('id', 0)

                const { error: backupError } = await supabase
                    .from('position_backups')
                    .insert([{
                        batch_id: batchId,
                        previous_data: previousData,
                        added_ids: addedIds
                    }])
                
                if (backupError) {
                    console.error('Failed to save backup:', backupError)
                    this.$store.dispatch('createAlert', { type: 'warning', message: 'Upload successful but backup failed. Revert will not be available.' })
                }
            }

            this.loadingDialog = false
            this.previewDialog = false
            this.$store.dispatch('createAlert', { type: 'success', message: `Processed: ${successCount} successful, ${failCount} failed` })
            this.getPositions()
        },

        async revertUpload() {
            if (!confirm('Are you sure you want to revert the last bulk upload? This cannot be undone.')) return

            this.loadingDialog = true
            
            // 1. Fetch latest backup
            const { data: backups, error: fetchError } = await supabase
                .from('position_backups')
                .select('*')
                .order('created_at', { ascending: false })
                .limit(1)

            if (fetchError || !backups || backups.length === 0) {
                this.loadingDialog = false
                this.$store.dispatch('createAlert', { type: 'error', message: 'No backup found to revert.' })
                return
            }

            const backup = backups[0]
            let revertErrors = []

            // 2. Revert Adds (Delete inserted rows)
            if (backup.added_ids && backup.added_ids.length > 0) {
                const { error: delError } = await supabase
                    .from('positions')
                    .delete()
                    .in('id', backup.added_ids)
                
                if (delError) revertErrors.push('Failed to delete added rows: ' + delError.message)
            }

            // 3. Revert Updates (Restore previous data)
            if (backup.previous_data && backup.previous_data.length > 0) {
                const { error: restoreError } = await supabase
                    .from('positions')
                    .upsert(backup.previous_data)
                
                if (restoreError) revertErrors.push('Failed to restore updated rows: ' + restoreError.message)
            }

            // 4. Cleanup Backup Record
            if (revertErrors.length === 0) {
                await supabase
                    .from('position_backups')
                    .delete()
                    .eq('id', backup.id)
                
                this.$store.dispatch('createAlert', { type: 'success', message: 'Revert successful.' })
            } else {
                this.$store.dispatch('createAlert', { type: 'error', message: 'Revert finished with errors: ' + revertErrors.join(', ') })
            }

            this.loadingDialog = false
            this.getPositions()
        }
    },


    components: { Viewer, PdfViewer, ValidityCheck, PositionHistory, PositionEmail },

    computed: {
       formTitle () {
            return this.editedIndex === -1 ? 'New Position' : 'Edit Position'
        },
       user() {
            return this.$store.getters.loadedUser
        },
        validity () {
            let user = this.$store.getters.loadedUser
            let sd = user.starts_on
            let ed = user.expires_on
            const now = new Date();
            const start = new Date(sd);
            const end = new Date(ed);
            return now >= start && now <= end;
        },
    },

    async mounted() {
        if(this.positions.length == 0) {
            this.getPositions()
            this.getColumns()
        }
    },
}
</script>